import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { StoreProvider } from "./store/StoreContext";
import { runCatalogValidation } from "./lib/catalogValidation";

function App() {
  useEffect(() => {
    runCatalogValidation();
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <StoreProvider>
        <BrowserRouter basename={__BASE_PATH__}>
          <AppRoutes />
        </BrowserRouter>
      </StoreProvider>
    </I18nextProvider>
  );
}

export default App;